export const APP_CONFIG_URL = (baseUrl: string, appId: string, tenantCode: string) => `${baseUrl}${appId}/live/Config?tc=${tenantCode}`;
 
export const APP_CONTENTS_URL = (baseUrl: string, appId: string, entryId: string) => `${baseUrl}${appId}/live/content/${entryId}?format=json`;
 
export const APP_CONTENTS_LIST_URL = (baseUrl: string, appId: string, categoryKey: string) => `${baseUrl}${appId}/live/contentList/${categoryKey}?format=json`;
 
export const APP_CONTENT_URL = (baseUrl: string, appId: string, entryId: string) => `${baseUrl}${appId}/live/content/${entryId}?format=json`;
 
export const CONTENT_DATA_TYPES = {
  URL: 'Url',
  HTML: 'HTML',
  OFFERS: 'Offers',
  RSVP_OFFERS: 'RSVPOffers',
  TOURNAMENT: 'Tournament',
  NONE: 'None'
};
 
export const CONTENT_ROUTES_PATHS = {
  LOGIN: 'login',
  OFFERS: 'Offers',
  OFFERS_DETAILS: 'offers-details',
  RSVPOFFERS: 'RSVPOffers',
  RSVP_OFFERS_DETAILS: 'rsvp-offers-details',
  DYNAMIC_CONTENT: 'dynamic-content',
  HTML_CONTENT_TYPE: 'html-content-type',
  ACCOUNT_SECURITY: 'account-security',
  CHANGE_PIN: 'change-pin',
  CHANGE_PASSWORD: 'change-password',
  ACCOUNT_INFORMATION: 'account-information',
  WIN_LOSS_STATEMENT: 'win-loss-statement',
  PLAYER_INFORMATION: 'player-information',
  PLAYER_PROFILE: 'player-profile',
  MFA: 'mfa'
};

export const AWS_CREDENTIALS_SEPARATOR = '::'
export const AWS_PASSPHRASE_CONSTANT = '@1234';
export const AWS_CONTENT_TYPE = 'application/x-amz-json-1.1';
export const IDENTITY_ID_X_AMZ_TARGET = 'AWSCognitoIdentityService.GetId';
export const IDENTITY_ID_X_AMZ_USER_AGENT = 'aws-sdk-flutter/1.0';
export const AWS_CREDENTIALS_X_AMZ_TARGET = 'AWSCognitoIdentityService.GetCredentialsForIdentity';
export const AWS_CREDENTIALS_X_AMZ_USER_AGENT = 'aws-sdk-flutter/1.0';
export const COGNITO_PREFIX_DOMAIN = 'https://cognito-identity';
export const COGNOTI_SUFFIX_DOMAIN = 'amazonaws.com';